import { connect } from 'react-redux';
import { getVocaboProbeDetailsData } from '../../../../utils/shared/probeDetailUtils';
import VocaboProbeDetails from '../../../../features/probeDetails/shared/vocabo/VocaboProbeDetails';
import { selectors } from '../../../../root/reading/root';
import fetchFormData from '../../../../api/forms/reading/formsActions';
import LinkWrapper from '../../../../features/navigation/LinkWrapper';

const mapStateToProps = (state, { result }) => {
    const location = selectors.getLocation(state);
    const isFormFetching = selectors.isFormFetching(state);
    const { tabs, subResult, selectedMeasure } = getVocaboProbeDetailsData({ result, location });
    const content = selectors.getFormByID(state, subResult.formUid);

    return { tabs, content, subResult, selectedMeasure, isFormFetching, LinkWrapper };
};

const mapDispatchToProps = dispatch => ({
    fetchFormData: (measure, formUid) => dispatch(fetchFormData(measure, formUid)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { measure, formUid } = stateProps.subResult;

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        fetchFormData: () => dispatchProps.fetchFormData(measure, formUid),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(VocaboProbeDetails);
